import React from 'react';
import FeatureDocumentation from '../../components/layouts/docsection';
import AddProductTemplate from "../../images/productTemplate.png";

const ProductTemplate = () => {
  const ProductTemplateDocs = {
    title: "Product Templates",
    description: "This documentation aims to guide you through the process of efficiently managing product templates. By understanding how to create and utilize these templates, you can streamline your product management tasks and ensure consistency across similar products.",
    sections: [
      {
        title: "Overview",
        content:
          "Product templates are predefined configurations designed for specific types of products, such as books, software applications, or other merchandise. These templates facilitate quicker product setup by providing a consistent framework that can be reused for similar products. By leveraging product templates, you can save time and maintain uniformity in product listings, making it easier for both administrators and customers to navigate the available options.",
      },
      {
        title: "Add Product Template",
        content:
          "To enhance your inventory management, you can create a new product template that will be applicable to a range of similar products. This allows you to standardize product information and ensure that essential details are consistently captured.",
        image: AddProductTemplate,
        imageAlt: "Add Product Template",
        imageCaption: "Figure 1: Comprehensive view of the add product template interface.",
        subsections: [
          {
            title: "How to Add a Product Template",
            content: "To initiate the creation of a new product template, click on the 'Create Product Template' button. This will allow you to start the process of defining the key characteristics of the template.",
            steps: [
              "1. Name and Description: Begin by providing a clear and concise name for the product template. Additionally, include a brief description that outlines the purpose and scope of the template. This information will help you and your team identify the template later.",
              "2. Body: The body of the product template contains essential components such as labels, a detailed description, and a required field that needs to be checked before finalizing the template. To enrich the template with additional labels, simply click on the plus button located below the existing labels. This feature allows for the customization of product information to better suit your inventory needs."
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation{...ProductTemplateDocs}/>
};

export default ProductTemplate;
